import { TextArea } from 'devextreme-react/text-area';
import { useContext, } from 'react';
import { Panel } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function WorkOrderInformationPanel() {

	const { order } = useContext(WorkOrderContext);

	return (
		<Panel
			className='wide-card'
			header={'Work Order Description'}
		>
			<TextArea height={150} value={order.details.description} readOnly={true} ></TextArea>
		</Panel>
	);
}
